
const defaultFormatter = new Intl.NumberFormat(
	'nl-BE',
	{
		minimumFractionDigits: 4,
		maximumFractionDigits: 4,
		style: 'currency',
		currency: 'EUR'
	}
);

export function formatToEuro(value: number) {
	return defaultFormatter.format(value);
}

export default '';